import { useQuery } from '@tanstack/react-query';
import { getUserRole } from '../services/moderationService';
import { useAuth } from '../contexts/AuthContext';

export function useUserRole() {
  const { user } = useAuth();

  const { data: userRole, isLoading } = useQuery({
    queryKey: ['userRole', user?.id],
    queryFn: getUserRole,
    enabled: !!user,
    staleTime: 1000 * 60 * 10, // 10 minutes
    gcTime: 1000 * 60 * 15,
  });

  const isAdmin = userRole === 'admin';
  const isModerator = userRole === 'moderator';
  const isAdminOrModerator = isAdmin || isModerator;

  return { userRole, isAdmin, isModerator, isAdminOrModerator, isLoading };
}
